module.exports = __webpack_public_path__ + "static/img/icon4.5e6f6b9d.png";